package com.example.mystybag.common.model

data class RadioButtonOption (
    var id          : Int       = 0,
    var text        : String    = "",
    var code        : String    = "",
    var isSelected  : Boolean   = false,
    var isBold      : Boolean   = false
)